import { CardActionsProps } from "@mui/material"
import { CardActions, styled } from "@tm/components"
import { offerItemClasses, offerItemName, offerItemSlots } from "@tm/themes"
import { classes } from "@tm/utils"
import { forwardRef } from "react"

const OfferItemActionsComponent = forwardRef<HTMLDivElement, CardActionsProps>((props, ref) => (
    <CardActions {...props} className={classes(offerItemClasses.actions, props.className)} ref={ref} />
))
export const OfferItemActions = styled(OfferItemActionsComponent, {
    name: offerItemName,
    slot: offerItemSlots.actions,
    overridesResolver: (_, styles) => styles.actions,
})({
    display: "flex",
    justifyContent: "space-between",
    maxWidth: "100%",
    ".add-to-basket": {
        div: {
            ".amount-field": {
                button: {
                    minWidth: "72px",
                    width: "72px",
                },
            },
            ".basketAmountField": {
                maxWidth: "72px",
                input: {
                    width: "50px",
                },
            },
        },
    },
})
